import { create } from "zustand";

export type HelpTab = "how" | "new";

interface Help {
  open: boolean;
  tab: HelpTab;
  /** Open the help overlay on a tab. Every "How does it work?" and "What's new" link goes through this. */
  show: (tab: HelpTab) => void;
  hide: () => void;
  setTab: (tab: HelpTab) => void;
}

/** Not persisted: whether the help overlay is open, and which tab, from anywhere in the app. */
export const useHelp = create<Help>()((set) => ({
  open: false,
  tab: "how",
  show: (tab) => set({ open: true, tab }),
  hide: () => set({ open: false }),
  setTab: (tab) => set({ tab }),
}));
